export default "__VITE_ASSET__Bpn22xnN__"